import { IApiTic } from '../models/iapi-tic'
import { ITaxCode } from '../models/itax-code.model'

export class TaxCodeAdapter {
  public mapApiTicResultsToITaxCode(apiResults: IApiTic): ITaxCode {
    return {
      ticId: apiResults.ticid,
      childrenCount: apiResults.childrenCount,
      description: apiResults.description,
      documentation: apiResults.documentation,
      isSSUTA: apiResults.isSSUTA,
      label: apiResults.label,
      parentTic: apiResults.parentTic,
      sstSortOrder: apiResults.sstSortOrder,
    }
  }
}
